import { Box, Text, TextProps, VStack } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { TooltipWithTouch } from '../TooltipWithTouch';

type Props = {
  textStyle?: TextProps['textStyle'];
  textColor?: TextProps['color'];
  names: string[];
  maxVisible?: number;
};

/**
 * NameList component - Displays a list of names with overflow handling
 * Shows the first name(s) and a "+n" indicator for remaining names
 * Hovering over "+n" shows a tooltip with all names
 */
export const NameList = ({
  names,
  maxVisible = 1,
  textStyle = 'body.s.regular',
  textColor = 'text.primary',
}: Props): ReactElement | null => {
  const effectiveTextStyle = textStyle;
  const effectiveTextColor = textColor;
  const visibleNames = names.slice(0, maxVisible);
  const remainingCount = names.length - maxVisible;
  const remainingNames = names.slice(maxVisible);

  return (
    <Text textStyle={effectiveTextStyle} color={effectiveTextColor} as="span">
      {visibleNames.join(', ')}
      {remainingCount > 0 && (
        <>
          {' '}
          <Box display="inline-flex">
            <TooltipWithTouch
              hasArrow
              label={
                <VStack gap="2xs" align="flex-start">
                  {remainingNames.map((name) => (
                    <Text key={uuidv4()} textStyle="body.s.regular" color="text.primary">
                      {name}
                    </Text>
                  ))}
                </VStack>
              }
              backgroundColor="text.primary"
              color="grey.white"
              borderRadius="s"
              py="xs"
              px="s"
              positioning={{ placement: 'top' }}
            >
              <Text
                as="span"
                textDecoration="underline"
                textDecorationStyle="dotted"
                textUnderlineOffset="2px"
                cursor="pointer"
                _hover={{
                  textDecorationColor: 'text.primary',
                }}
              >
                +{remainingCount}
              </Text>
            </TooltipWithTouch>
          </Box>
        </>
      )}
    </Text>
  );
};
